import { BaseDto } from "./base.dto"
import { DateOfBirthDto } from "./date-of-birth.dto"
import { FileDto } from "./file.dto"
import { PagingDto } from "./paging.dto"
import { ProductDto } from "./product.dto"

export class MerchantFindCollectionDto extends PagingDto {
  status: string
}

export class MerchantCollectionDto extends BaseDto {
  name: string
  nameKh: string
  icon: FileDto
  mobileIcon: FileDto
  enabled: boolean
  sortOrder: number
  endDate: DateOfBirthDto
  isJoined: boolean

  static create() {
    return new MerchantCollectionDto()
  }
}

export class MerchantCollectionItemDto extends BaseDto {
  status: string
  product: ProductDto
  productId: string
}

export class MerchantDeleteCollectionItemDto {
  productIds: string
}

export class MerchantCreateCollectionItemDto {
  isAll: boolean
  productIds: string
}

export enum CollectionStatus {
  Pending = 'pending',
  Approved = 'approved',
  Reject = 'rejected'
}